module.exports = __webpack_public_path__ + "img/P150T_weapon_107.4e03752f.png";